module.exports = __webpack_public_path__ + "static/media/journalism-dark.a5847812.png";